export const environment = {
  production: true,
  URL_SITE: "https://whowhywhat.fr",
  URL_MEDIA_API: "https://whowhywhat.fr/admin",
  URL_SHARE: "https://whowhywhat.fr/share",
  opencreations: true
};


